var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: '1fr',
        gap: '6px',
      },
      {
        size: 2,
        columns: '1fr',
        gap: '10px',
      },
    ]}},[(_vm.loadError)?_c('div',[_vm._v(_vm._s(_vm.cms.copy_no_results))]):_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},_vm._l((_vm.jobDepartments),function(department){return _c('div',{key:department.id},[_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"cms":{ heading: department.name },"html-tag":"h3"}}),_vm._v(" "),_vm._l((department.jobs),function(job){return _c('div',{key:job.id,class:`${_vm.name}__job`,attrs:{"data-id":job.id}},[_c('a-link-v2',{class:[`${_vm.name}__link`],attrs:{"url":_vm.getJobURL(job.id)}},[_c('div',{class:`${_vm.name}__job-select`},[_c('i',{class:[`${_vm.name}__icon`, `${_vm.name}__icon-before`, _vm.icon]})]),_vm._v(" "),_c('a-copy',{class:`${_vm.name}__job-entry`,attrs:{"cms":{ heading: job.title }}})],1)],1)})],2)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }